import _ from 'lodash'

import { useAdminAuthStore } from '@/stores/admin/auth.js'

import { RETAILER_USER_TYPE } from '@/constants/constants.js'

const VueCan = {
  install(app, options) {
    app.config.globalProperties.$can = (permission, checkAdmin = true) => {
      const authStore = useAdminAuthStore()
      const permissions = authStore.permissions

      if (authStore.isAdmin === true && checkAdmin) {
        return true
      } else if (_.isArray(permission)) {
        let result = true
        permission.forEach(p => {
          if (!permissions.includes(p)) {
            result = false
          }
        })
        return result
      } else if (permissions.includes(permission)) {
        return true
      }

      return false
    }

    app.config.globalProperties.$retailerCan = (user, roles = []) => {
      if (user.is_owner === RETAILER_USER_TYPE.OWNER) {
        return true
      }

      if (!roles.length) {
        return false
      }

      return roles.includes(user.role)
    }

    const $can = app.config.globalProperties.$can
    const $retailerCan = app.config.globalProperties.$retailerCan

    app.provide('VueCan', { $can, $retailerCan })
  }
}

export default VueCan
